import script from "./RepeatFault.vue?vue&type=script&setup=true&lang=js"
export * from "./RepeatFault.vue?vue&type=script&setup=true&lang=js"

import "./RepeatFault.vue?vue&type=style&index=0&id=0c174387&scoped=true&lang=less"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c174387"]])

export default __exports__